<p class="fw-bold">{{ 'importProjectSummaryPopup.title' | translate }}</p>

<app-table [data]="caeImportErrors()">
  <app-table-column [header]="'caeImport.error.header.rail' | translate" [width]="'auto'">
    <ng-template let-error>{{ error.rail }}</ng-template>
  </app-table-column>
  <app-table-column [header]="'caeImport.error.header.railId' | translate" [width]="'auto'">
    <ng-template let-error>{{ error.railId }}</ng-template>
  </app-table-column>
  <app-table-column [header]="'caeImport.error.header.item' | translate" [width]="'auto'">
    <ng-template let-error>{{ error.item }}</ng-template>
  </app-table-column>
  <app-table-column [header]="'caeImport.error.header.itemId' | translate" [width]="'auto'">
    <ng-template let-error>{{ error.itemId }}</ng-template>
  </app-table-column>
  <app-table-column [header]="'caeImport.error.header.itemNo' | translate" [width]="'auto'">
    <ng-template let-error>{{ error.itemNo }}</ng-template>
  </app-table-column>
  <app-table-column [header]="'global.label.hint' | translate" [width]="'1fr'">
    <ng-template let-error>{{ error.messageKey | translate: toTranslateParams(error.messageParams) }}</ng-template>
  </app-table-column>
</app-table>
